import GenericTableResponse from "@/models/api/GenericTableResponse";
import { Expose, Type } from "class-transformer";
import { IsNumber, IsString, ValidateNested } from "class-validator";

export class GetCashReportItem {
  @Expose()
  @IsNumber()
  id!: number; // 5319
  @Expose()
  @IsString()
  name!: string; // "Raport kasowy za okres 2021-12-16 - 2021-12-16"
}

export default class GetCashReportsDataTableResponse extends GenericTableResponse<GetCashReportItem> {
  @Type(() => GetCashReportItem)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
      // @ts-ignore
  items!: Array<GetCashReportItem>;
}
